import React from "react";
import makeDonationIcon from "../../assets/images/icons/make-donation-icon.png";
import helpIcon from "../../assets/images/icons/help-icon.png";
import programsIcon from "../../assets/images/icons/programs-icon.png";
import ourMissionIcon from "../../assets/images/icons/our-mission-icon.png";

const AboutUs = () => (
  <div className="section-home about-us fadeIn animated">
    <div className="container">
      <div className="row">
        <div className="col-md-3 col-sm-6">
          <div className="about-us-col">
            <div className="col-icon-wrapper">
              <img src={ourMissionIcon} alt="" />
            </div>
            <h3 className="col-title">our mission</h3>
            <div className="col-details">
              <p>
                Lorem ipsum dolor sit amet consect adipisscin elit proin vel
                lectus ut eta esami vera dolor sit amet consect
              </p>
            </div>
            <div className="btn btn-primary"> Read more </div>
          </div>
        </div>

        <div className="col-md-3 col-sm-6">
          <div className="about-us-col">
            <div className="col-icon-wrapper">
              <img src={makeDonationIcon} alt="" />
            </div>
            <h3 className="col-title">Make donations</h3>
            <div className="col-details">
              <p>
                Lorem ipsum dolor sit amet consect adipisscin elit proin vel
                lectus ut eta esami vera dolor sit amet consect
              </p>
            </div>
            <div className="btn btn-primary"> Read more </div>
          </div>
        </div>

        <div className="col-md-3 col-sm-6">
          <div className="about-us-col">
            <div className="col-icon-wrapper">
              <img src={helpIcon} alt="" />
            </div>
            <h3 className="col-title">Help & support</h3>
            <div className="col-details">
              <p>
                Lorem ipsum dolor sit amet consect adipisscin elit proin vel
                lectus ut eta esami vera dolor sit amet consect
              </p>
            </div>
            <div className="btn btn-primary"> Read more </div>
          </div>
        </div>

        <div className="col-md-3 col-sm-6">
          <div className="about-us-col">
            <div className="col-icon-wrapper">
              <img src={programsIcon} alt="" />
            </div>
            <h3 className="col-title">our programs</h3>
            <div className="col-details">
              <p>
                Lorem ipsum dolor sit amet consect adipisscin elit proin vel
                lectus ut eta esami vera dolor sit amet consect
              </p>
            </div>
            <div className="btn btn-primary"> Read more </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default AboutUs;
